import { Box } from '@mui/material';
import React from 'react';

const AnimatedEllipsis: React.FC = () => (
	<Box component="span" aria-hidden sx={{ display: 'inline-flex' }}>
		{[0, 1, 2].map((i) => (
			<Box
				key={i}
				component="span"
				sx={{
					animation: 'ellipsisFade 1.4s infinite ease-in-out',
					animationDelay: `${i * 0.2}s`,
					'@keyframes ellipsisFade': {
						'0%, 60%, 100%': { opacity: 0 },
						'30%': { opacity: 1 },
					},
					marginLeft: '0.25em',
				}}
			>
				.
			</Box>
		))}
	</Box>
);

export default AnimatedEllipsis;
